import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.analysis');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-analysis',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.analysis/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.analysis-page {
  min-height: 100%;
}

.analysis-content {
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  overflow: visible;
}

.metabolic-gauge-layout {
  align-items: center;
  display: grid;
  gap: 18px;
  grid-template-columns: 128px minmax(0, 1fr);
}

.score-gauge {
  align-items: center;
  aspect-ratio: 1;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  padding: 12px;
}

.score-gauge-inner {
  align-items: center;
  background: var(--th-card-bg);
  border-radius: 50%;
  box-shadow: inset 0 0 0 1px var(--th-line);
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  width: 100%;
}

.score-gauge-inner strong {
  color: var(--th-text);
  font-size: 28px;
  font-weight: 800;
  line-height: 1;
}

.score-gauge-inner span {
  color: var(--th-text-subtle);
  font-size: var(--th-font-small);
  font-weight: 700;
  margin-top: 6px;
}

.metabolic-copy {
  min-width: 0;
}

.metabolic-scale {
  color: var(--th-text-subtle);
  display: grid;
  font-size: var(--th-font-small);
  font-weight: 700;
  gap: 6px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-top: 14px;
}

.metabolic-scale span {
  background: var(--th-surface-soft);
  border: 1px solid var(--th-line);
  border-radius: 8px;
  padding: 7px 6px;
  text-align: center;
}

.risk-column-chart,
.lifestyle-column-chart {
  align-items: end;
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(auto-fit, minmax(58px, 1fr));
  min-height: 180px;
}

.risk-column,
.lifestyle-column {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 7px;
  min-width: 0;
}

.risk-track,
.lifestyle-track {
  align-items: end;
  background: var(--th-surface-soft);
  border: 1px solid var(--th-line);
  border-radius: 10px;
  display: flex;
  height: 112px;
  overflow: hidden;
  padding: 4px;
  width: 100%;
}

.risk-bar,
.lifestyle-bar {
  border-radius: 7px;
  min-height: 10px;
  transition: height 180ms ease;
  width: 100%;
}

.risk-low,
.lifestyle-bar-good {
  background: var(--th-status-good);
}

.risk-moderate,
.lifestyle-bar-warning {
  background: var(--th-status-warning);
}

.risk-high {
  background: var(--th-status-danger);
}

.lifestyle-bar-normal {
  background: var(--th-status-info);
}

.risk-value,
.lifestyle-value {
  color: var(--th-text);
  font-size: var(--th-font-small);
  font-weight: 800;
}

.risk-label,
.lifestyle-label {
  color: var(--th-text-muted);
  font-size: var(--th-font-small);
  font-weight: 700;
  overflow-wrap: anywhere;
  text-align: center;
}

.risk-level {
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 800;
  line-height: 1;
  padding: 5px 8px;
}

.risk-level-low {
  background: var(--th-status-good-soft);
  color: var(--th-status-good-text);
}

.risk-level-moderate {
  background: var(--th-status-warning-soft);
  color: var(--th-status-warning-text);
}

.risk-level-high {
  background: var(--th-status-danger-soft);
  color: var(--th-status-danger-text);
}

.lifestyle-good {
  color: var(--th-status-good-text);
}

.lifestyle-normal {
  color: var(--th-status-info-text);
}

.lifestyle-warning {
  color: var(--th-status-warning-text);
}

.rhythm-section-head {
  align-items: flex-start;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  padding: 0 var(--analysis-edge-x);
  margin-bottom: 14px;
}

.rhythm-status-chip {
  background: var(--th-status-good-soft);
  border-radius: 9999px;
  color: var(--th-status-good-text);
  flex-shrink: 0;
  font-size: var(--th-font-small);
  font-weight: 800;
  line-height: 1;
  padding: 8px 11px;
}

.rhythm-analysis-section {
  --analysis-edge-x: 20px;
  margin-left: calc(var(--analysis-edge-x) * -1);
  margin-right: calc(var(--analysis-edge-x) * -1);
  overflow: visible;
  padding-top: 4px;
  width: calc(100% + var(--analysis-edge-x) * 2);
}

.rhythm-summary-grid {
  display: grid;
  gap: 0;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-bottom: 16px;
  padding: 0 var(--analysis-edge-x);
}

.rhythm-summary-tile {
  border-left: 1px solid var(--th-line);
  min-width: 0;
  padding: 2px 10px;
}

.rhythm-summary-tile:first-child {
  border-left: 0;
  padding-left: 0;
}

.rhythm-summary-tile span {
  color: var(--th-text-subtle);
  display: block;
  font-size: var(--th-font-small);
  font-weight: 700;
  overflow-wrap: anywhere;
}

.rhythm-summary-tile strong {
  color: var(--th-text);
  display: block;
  font-size: var(--th-font-body);
  font-weight: 800;
  margin-top: 5px;
  overflow-wrap: anywhere;
}

.analysis-line-panel {
  background: radial-gradient(circle at 14% 10%, rgba(96, 165, 250, 0.18), transparent 34%), radial-gradient(circle at 88% 18%, rgba(52, 211, 153, 0.16), transparent 32%), linear-gradient(180deg, rgba(255, 255, 255, 0.62), rgba(255, 255, 255, 0)), var(--th-surface-soft);
  border-bottom: 1px solid var(--th-line);
  border-top: 1px solid var(--th-line);
  overflow: visible;
  padding: 16px 0 10px;
  width: 100%;
}

.analysis-chart-head {
  align-items: center;
  display: flex;
  gap: 10px;
  justify-content: space-between;
  margin-bottom: 8px;
  padding: 0 var(--analysis-edge-x);
}

.rhythm-legend {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  min-width: 0;
}

.rhythm-legend-item {
  align-items: center;
  color: var(--th-text-subtle);
  display: inline-flex;
  font-size: 12px;
  font-weight: 800;
  gap: 5px;
  line-height: 1;
}

.rhythm-legend-item::before {
  border-radius: 9999px;
  content: "";
  display: block;
  height: 7px;
  width: 16px;
}

.rhythm-legend-target::before {
  background: var(--th-status-good-soft);
}

.rhythm-legend-line::before {
  background: var(--th-chart-line);
}

.rhythm-range-note {
  color: var(--th-text-muted);
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 800;
}

.analysis-chart-scroll {
  margin: 0;
  overflow-x: auto;
  overflow-y: visible;
  padding: 14px var(--analysis-edge-x) 8px;
  scrollbar-width: thin;
}

.analysis-chart-canvas {
  color: var(--th-chart-line);
  min-width: 720px;
  width: max(100%, 720px);
}

.analysis-line-chart {
  display: block;
  height: 210px;
  overflow: visible;
  width: 100%;
}

.analysis-target-band {
  fill: var(--th-status-good-soft);
  opacity: 0.65;
}

.analysis-line-grid {
  stroke: var(--th-line);
  stroke-dasharray: 4 5;
  stroke-width: 1;
}

.analysis-line-target {
  stroke: var(--th-status-good-text);
  stroke-dasharray: 5 6;
  stroke-linecap: round;
  stroke-width: 1.2;
}

.analysis-line-area {
  fill: var(--th-chart-area);
}

.analysis-line {
  fill: none;
  stroke: var(--th-chart-line);
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 4.2;
}

.analysis-line-point {
  fill: var(--th-card-bg);
  stroke: var(--th-chart-line);
  stroke-width: 3.2;
}

.analysis-line-point-low {
  stroke: var(--th-status-warning);
}

.analysis-line-point-peak {
  fill: var(--th-chart-line);
}

.analysis-axis-label,
.analysis-line-value {
  font-size: 10px;
  font-weight: 900;
  pointer-events: none;
}

.analysis-axis-label {
  fill: var(--th-text-muted);
  opacity: 0.76;
}

.analysis-line-value {
  fill: var(--th-text);
}

.analysis-line-labels {
  color: var(--th-text-subtle);
  display: grid;
  font-size: var(--th-font-small);
  font-weight: 700;
  gap: 10px;
  grid-template-columns: repeat(6, minmax(86px, 1fr));
  padding: 3px 0 0 30px;
}

.analysis-line-labels span {
  overflow-wrap: anywhere;
  text-align: center;
}

.rhythm-detail-list {
  display: grid;
  margin-top: 14px;
}

.rhythm-detail-row {
  --metric-accent: var(--th-chart-line);
  --metric-soft: var(--th-status-info-soft);
  --metric-border: var(--th-status-info-border);
  background: linear-gradient(90deg, var(--metric-soft), rgba(255, 255, 255, 0) 72%), transparent;
  border-top: 1px solid var(--th-line);
  display: grid;
  gap: 9px;
  min-width: 0;
  padding: 13px var(--analysis-edge-x);
}

.rhythm-detail-row:last-child {
  border-bottom: 1px solid var(--th-line);
}

.rhythm-detail-sleep {
  --metric-accent: #6366f1;
  --metric-soft: rgba(99, 102, 241, 0.13);
  --metric-border: rgba(99, 102, 241, 0.28);
}

.rhythm-detail-wake {
  --metric-accent: #f59e0b;
  --metric-soft: rgba(245, 158, 11, 0.14);
  --metric-border: rgba(245, 158, 11, 0.3);
}

.rhythm-detail-activity {
  --metric-accent: #06b6d4;
  --metric-soft: rgba(6, 182, 212, 0.14);
  --metric-border: rgba(6, 182, 212, 0.3);
}

.rhythm-detail-recovery {
  --metric-accent: #10b981;
  --metric-soft: rgba(16, 185, 129, 0.14);
  --metric-border: rgba(16, 185, 129, 0.32);
}

.rhythm-detail-stress {
  --metric-accent: #f43f5e;
  --metric-soft: rgba(244, 63, 94, 0.13);
  --metric-border: rgba(244, 63, 94, 0.3);
}

.rhythm-detail-row-head {
  align-items: flex-start;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  min-width: 0;
}

.rhythm-detail-kicker {
  color: var(--metric-accent);
  display: block;
  font-size: 11px;
  font-weight: 900;
  line-height: 1;
  margin-bottom: 6px;
}

.rhythm-detail-title {
  color: var(--th-text-muted);
  font-size: var(--th-font-body);
  font-weight: 900;
  line-height: 1.2;
  margin: 0;
  min-width: 0;
  overflow-wrap: anywhere;
}

.rhythm-detail-score {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: 5px;
}

.rhythm-detail-score strong {
  color: var(--th-text);
  font-size: 24px;
  font-weight: 900;
  line-height: 1;
}

.rhythm-detail-score span {
  color: var(--metric-accent);
  font-size: 11px;
  font-weight: 900;
  line-height: 1;
}

.rhythm-detail-visual {
  min-height: 34px;
}

.rhythm-detail-progress {
  align-items: center;
  background: var(--th-surface-soft);
  border-radius: 9999px;
  display: flex;
  height: 12px;
  min-height: 12px;
  overflow: hidden;
  padding: 2px;
}

.rhythm-detail-progress span {
  background: linear-gradient(90deg, var(--metric-accent), var(--th-chart-line));
  border-radius: inherit;
  display: block;
  height: 100%;
  min-width: 10px;
}

.rhythm-detail-ticks,
.rhythm-detail-alert {
  align-items: end;
  display: grid;
  gap: 5px;
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.rhythm-detail-ticks span,
.rhythm-detail-alert span {
  background: var(--th-surface-soft);
  border-radius: 9999px;
  display: block;
  height: 28px;
}

.rhythm-detail-ticks span.is-active {
  background: var(--metric-accent);
}

.rhythm-detail-alert span {
  height: 10px;
}

.rhythm-detail-alert span.is-active {
  background: linear-gradient(90deg, #f59e0b, var(--metric-accent));
}

.rhythm-detail-timeline {
  align-items: center;
  display: grid;
  gap: 8px;
  grid-template-columns: minmax(0, 1fr) auto;
  position: relative;
}

.rhythm-timeline-track {
  background: var(--th-surface-soft);
  border-radius: 9999px;
  display: block;
  height: 6px;
  position: relative;
}

.rhythm-timeline-pin {
  background: var(--metric-accent);
  border: 3px solid var(--th-card-bg);
  border-radius: 9999px;
  box-shadow: 0 0 0 2px var(--metric-border);
  height: 16px;
  position: absolute;
  top: 9px;
  transform: translateX(-50%);
  width: 16px;
}

.rhythm-detail-timeline strong,
.rhythm-detail-pulse strong {
  color: var(--th-text);
  font-size: var(--th-font-small);
  font-weight: 900;
}

.rhythm-detail-bars {
  align-items: end;
  display: flex;
  gap: 5px;
  height: 34px;
}

.rhythm-detail-bars span {
  background: linear-gradient(180deg, var(--metric-accent), rgba(6, 182, 212, 0.3));
  border-radius: 9999px 9999px 4px 4px;
  flex: 1;
  min-height: 8px;
}

.rhythm-detail-pulse {
  align-items: center;
  display: flex;
  gap: 6px;
}

.rhythm-detail-pulse span {
  border: 2px solid var(--metric-accent);
  border-radius: 9999px;
  display: block;
}

.rhythm-detail-pulse span:nth-child(1) {
  height: 16px;
  opacity: 0.42;
  width: 16px;
}

.rhythm-detail-pulse span:nth-child(2) {
  height: 24px;
  opacity: 0.68;
  width: 24px;
}

.rhythm-detail-pulse span:nth-child(3) {
  background: var(--metric-accent);
  height: 30px;
  width: 30px;
}

.rhythm-detail-note {
  color: var(--th-text-subtle);
  font-size: var(--th-font-small);
  margin: 5px 0 0;
  overflow-wrap: anywhere;
}

:host-context(.app-container[data-mode=dark]) .analysis-line-panel {
  background: radial-gradient(circle at 18% 12%, rgba(96, 165, 250, 0.16), transparent 34%), radial-gradient(circle at 86% 20%, rgba(52, 211, 153, 0.13), transparent 32%), linear-gradient(180deg, rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0)), var(--th-surface-soft);
}

:host-context(.app-container[data-mode=dark]) .rhythm-detail-row {
  background: linear-gradient(90deg, var(--metric-soft), rgba(17, 24, 39, 0) 72%), transparent;
}

@media (max-width: 430px) {
  .rhythm-analysis-section {
    --analysis-edge-x: 16px;
  }
  .analysis-chart-canvas {
    min-width: 660px;
    width: max(100%, 660px);
  }
}
@media (max-width: 380px) {
  .metabolic-gauge-layout {
    grid-template-columns: 1fr;
  }
  .score-gauge {
    justify-self: center;
    width: 128px;
  }
  .rhythm-section-head,
  .analysis-chart-head {
    align-items: flex-start;
    flex-direction: column;
  }
  .rhythm-summary-grid {
    gap: 8px;
    grid-template-columns: 1fr;
  }
  .rhythm-summary-tile {
    border-left: 0;
    border-top: 1px solid var(--th-line);
    padding: 8px 0 0;
  }
  .rhythm-summary-tile:first-child {
    border-top: 0;
    padding-top: 0;
  }
}`],
})
export class PageAnalysisComponent implements OnInit {
    public theme: string = 'b';
    public activeTab: string = 'overview';
    public lineGridLevels: number[] = [50, 70, 85];
    public lineChartStart: number = 30;
    public lineChartEnd: number = 302;
    public lineChartWidth: number = 272;
    public lineChartBaseline: number = 128;
    public lineChartHeight: number = 108;
    public rhythmTicks: number[] = [1, 2, 3, 4, 5];

    public tabs: any[] = [
        { id: 'overview', label: '종합 분석' },
        { id: 'oriental', label: '한의 분석' }
    ];

    public overviewData: any = {
        metabolicRisk: 'low',
        metabolicScore: 25,
        circadianScore: 72,
        lifestyleScore: 65,
        comparisonPercentile: 68
    };

    public vitalSigns: any[] = [
        { label: '평균 심박수', value: '72', unit: 'bpm', trend: 'stable' },
        { label: '평균 수면', value: '6.5', unit: '시간', trend: 'down' },
        { label: '일평균 걸음', value: '4,200', unit: '보', trend: 'up' }
    ];

    public orientalData: any = {
        constitution: '소음인',
        temperatureType: '한(寒)',
        lifestyleIndexes: [
            { label: '활동량', score: 60, status: 'normal' },
            { label: '수면', score: 45, status: 'warning' },
            { label: '식이', score: 70, status: 'normal' },
            { label: '음주', score: 85, status: 'good' },
            { label: '흡연', score: 100, status: 'good' }
        ]
    };

    public riskFactors: any[] = [
        { label: '당뇨', risk: 18, level: 'low' },
        { label: '고혈압', risk: 32, level: 'moderate' },
        { label: '고지혈증', risk: 22, level: 'low' },
        { label: '심혈관질환', risk: 15, level: 'low' }
    ];

    public linkedSources: any[] = [
        { icon: 'medical', label: '국가건강검진', status: '최근 1회 연동', desc: '혈압·혈당·중성지방 반영' },
        { icon: 'watch', label: '스마트헬스', status: '자동 수집', desc: '걸음·수면·심박 데이터 반영' },
        { icon: 'microphone', label: '챗봇 문진', status: '누락 보완', desc: '생활습관/한의 문진 3문항' }
    ];

    public rhythmStability: any[] = [
        { label: '수면 시작', group: '수면', score: 76, detail: '취침 편차 28분', badge: '안정', tone: 'sleep', visual: 'bar' },
        { label: '수면 유지', group: '수면', score: 72, detail: '중간 각성 1.4회', badge: '관찰', tone: 'sleep', visual: 'ticks' },
        { label: '기상 규칙', group: '기상', score: 83, detail: '기상 편차 18분', badge: '우수', tone: 'wake', visual: 'time', time: '06:50' },
        { label: '오전 활동', group: '활동', score: 79, detail: '활동 시작 07:40', badge: '상승', tone: 'activity', visual: 'bars', bars: [34, 48, 58, 72, 88] },
        { label: '심박 회복', group: '회복', score: 86, detail: '회복 심박 안정', badge: '최고', tone: 'recovery', visual: 'pulse', pulse: '66' },
        { label: '스트레스', group: '변동', score: 68, detail: '저녁 변동 주의', badge: '주의', tone: 'stress', visual: 'alert' }
    ];

    public rhythmSummary: any = {
        status: '양호',
        range: '목표 70-85',
        metrics: [
            { label: '평균 안정도', value: '77점' },
            { label: '최고 구간', value: '심박 회복' },
            { label: '변동폭', value: '18점' }
        ]
    };

    public reportHighlights: any[] = [
        { icon: 'users', title: '비교 그룹 리포트', desc: '동일 연령·성별 대비 상위 68%' },
        { icon: 'alert', title: '예측 경고', desc: '혈압·수면 리듬 변동 주의' },
        { icon: 'herb', title: '맞춤 양생', desc: '체질/한열 맞춤 생활관리 가이드' }
    ];

    public questionnaireItems: any[] = [
        { icon: 'chat', title: '어젯밤 몇 시에 주무셨나요?', desc: '수면 리듬 보완 문항' },
        { icon: 'food', title: '오늘 식사는 규칙적이었나요?', desc: '식이 패턴 수집 문항' },
        { icon: 'mood', title: '기분 변화가 있었나요?', desc: '정신건강 위험도 보완 문항' }
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.theme = localStorage.getItem('app-theme') || 'b';
        await this.service.render();
    }

    public async switchTab(tabId: string) {
        this.activeTab = tabId;
        await this.service.render();
    }

    public getGaugeBackground(score: number, color: string): string {
        const value = this.clampScore(score);
        const end = value * 3.6;
        return `conic-gradient(${color} 0deg ${end}deg, var(--th-surface-soft) ${end}deg 360deg)`;
    }

    public getRiskLevelLabel(level: string): string {
        if (level === 'moderate') return '주의';
        if (level === 'high') return '높음';
        return '낮음';
    }

    public getRiskGaugeColor(level: string): string {
        if (level === 'moderate') return 'var(--th-status-warning)';
        if (level === 'high') return 'var(--th-status-danger)';
        return 'var(--th-status-good)';
    }

    public getLinePoints(items: any[]): string {
        if (!Array.isArray(items) || items.length === 0) {
            return '';
        }

        return items.map((item: any, index: number) => {
            return `${this.getLineX(index, items.length)},${this.getLineY(item.score)}`;
        }).join(' ');
    }

    public getLineAreaPoints(items: any[]): string {
        if (!Array.isArray(items) || items.length === 0) {
            return '';
        }

        const firstX = this.getLineX(0, items.length);
        const lastX = this.getLineX(items.length - 1, items.length);
        return `${firstX},${this.lineChartBaseline} ${this.getLinePoints(items)} ${lastX},${this.lineChartBaseline}`;
    }

    public getLineX(index: number, total: number): number {
        if (total <= 1) {
            return Math.round(((this.lineChartStart + this.lineChartEnd) / 2) * 10) / 10;
        }

        return Math.round((this.lineChartStart + (this.lineChartWidth / (total - 1)) * index) * 10) / 10;
    }

    public getLineY(score: number): number {
        const value = this.clampScore(score);
        return Math.round((this.lineChartBaseline - (value / 100) * this.lineChartHeight) * 10) / 10;
    }

    public getLineBandY(maxScore: number): number {
        return this.getLineY(maxScore);
    }

    public getLineBandHeight(minScore: number, maxScore: number): number {
        return Math.max(0, this.getLineY(minScore) - this.getLineY(maxScore));
    }

    public getRhythmTickCount(score: number): number {
        return Math.max(1, Math.ceil(this.clampScore(score) / 20));
    }

    private clampScore(score: number): number {
        const value = Number(score) || 0;
        return Math.max(0, Math.min(100, value));
    }
}

export default PageAnalysisComponent;